import { render, staticRenderFns } from "./NewsFilled.vue?vue&type=template&id=9bbcb7b0"
import script from "./NewsFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsFilled.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports